import React, { useEffect, useState } from "react";
import classes from "./CustomerSales.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../Components/API/Api";
import { Pencil, Trash2, Printer } from "lucide-react";
import Swal from "sweetalert2";

const CustomerSales = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [amountToBePaidInput, setAmountToBePaidInput] = useState("");
  const [customerLedgers, setCustomerLedgers] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [showLedgerButton, setShowLedgerButton] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // ===== Helpers =====
  const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
  };
  const formatIntegerWithCommas = (digits) => {
    if (!digits) return "";
    const n = Number(digits);
    if (isNaN(n)) return "";
    return n.toLocaleString("en-NG", { maximumFractionDigits: 0 });
  };

  const getPaymentStatus = (debtAmount, totalAmount) => {
    const debtNum = parseFloat(debtAmount || 0);
    const totalNum = parseFloat(totalAmount || 0);

    if (debtNum === 0) return { status: "Paid", className: "statusPaid" };
    if (debtNum === totalNum) return { status: "Owing", className: "statusOwing" };
    return { status: "Paid Part", className: "statusPartialPaid" };
  };
  const [modalData, setModalData] = useState({
    invoiceNumber: "",
    customerName: "",
    totalAmount: 0,
    subTotal: 0,
    outstandingBalance: 0,
    amountToBePaid: 0,
    description: "",
    transactionDate: "",
  });

  const openEditModal = (invoice) => {
    // Add null/undefined checks
    if (!invoice) {
      console.error("Invoice is undefined or null");
      return;
    }

    setSelectedInvoice(invoice);
    setModalData({
      invoiceNumber: invoice?.invoice_number || invoice?.uuid || "",
      customerName:
        invoice?.customer?.name ||
        `Customer ${invoice?.customer_id || "Unknown"}` ||
        "",
      totalAmount: parseFloat(invoice?.total_price || invoice?.amount || 0),
      subTotal: parseFloat(invoice?.sub_total || 0),
      outstandingBalance: parseFloat(invoice?.debit || invoice?.balance || 0),
      amountToBePaid: 0,
      description: invoice?.description || "",
      transactionDate: invoice?.transaction_date || "",
    });
    setAmountToBePaidInput("");

    setIsEditModalOpen(true);
  };
  const handleModalInputChange = (field, value) => {
    setModalData((prev) => {
      let updated = { ...prev };

      if (field === "amountToBePaid") {
        const digitsOnly = String(value || "").replace(/\D/g, "");
        setAmountToBePaidInput(digitsOnly);
        const parsed = digitsOnly ? parseInt(digitsOnly, 10) : 0;
        updated.amountToBePaid = parsed;
        const originalBalance = parseFloat(
          selectedInvoice?.debit || selectedInvoice?.balance || 0
        );
        const newBalance = Math.max(0, originalBalance - parsed);
        updated.outstandingBalance = newBalance;
        return updated;
      }

      updated[field] = value;

      // If amount to be paid changes, calculate new outstanding balance
      // (Handled above with formatted parsing)

      return updated;
    });
  };

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  //   // ===== Fetch Invoices =====
  //   useEffect(() => {
  //     const fetchInvoices = async () => {
  //       try {
  //         const token = localStorage.getItem("authToken");
  //         const response = await axios.get(`${BASE_URL}/v1/fetch-sales-invoice`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         });
  //         setInvoiceItems(response.data.data || []);
  //       } catch (error) {
  //         console.error("Failed to fetch invoices:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     fetchInvoices();
  //   }, []);





  //   /api/v1/customer/get-customer-ledger
  // ===== Fetch Customers =====
  useEffect(() => {
    const fetchCustomers = async () => {
      setCustomerLoading(true);
      try {
        const res = await api.get(`/v1/customer`);
        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err);
      } finally {
        setCustomerLoading(false);
      }
    };
    fetchCustomers();
  }, []);
  const fetchLedgerForCustomer = async (customerId) => {
    setLedgerLoading(true);
    try {
      const response = await api.get(`/v1/customer/get-customer-ledger`, { params: { customer_id: customerId } });

      const ledgerData = response.data.data || [];
      setCustomerLedgers(ledgerData);

      // Optional: calculate totals
      const totalBalance = ledgerData.reduce((sum, entry) => sum + parseFloat(entry.balance || 0), 0);
      const totalCredit = ledgerData.reduce((sum, entry) => sum + parseFloat(entry.credit || 0), 0);
      const totalDebt = ledgerData.reduce((sum, entry) => sum + parseFloat(entry.debit || 0), 0);

      setCustomerDetails({
        id: customerId,
        totalSales: totalBalance,
        totalPaid: totalCredit,
        totalOutstanding: totalDebt,
        totalInvoices: ledgerData.length,
      });

    } catch (error) {
      console.error("Failed to fetch ledger for customer:", error);
      setCustomerLedgers([]);
    } finally {
      setLedgerLoading(false);
    }
  };


  //   useEffect(() => {
  //     const fetchCustomersLedger = async () => {
  //       const token = localStorage.getItem("authToken");
  //       setCustomerLoading(true);
  //       try {
  //         const res = await axios.get(`${BASE_URL}/v1/customer/get-customer-ledger`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         });
  //         const customerData = res.data?.data?.data || res.data?.data || [];
  //         setCustomers(customerData);
  //       } catch (err) {
  //         console.error("Error fetching customer's Ledger:", err);
  //       } finally {
  //         setCustomerLoading(false);
  //       }
  //     };
  //     fetchCustomersLedger();
  //   }, []);

  const handleCustomerSelect = (customer) => {
    if (!customer) return;

    // Use already fetched ledger data
    const ledgers = customer.ledgers || [];
    const totalSales = ledgers.reduce((sum, entry) => sum + parseFloat(entry.balance || 0), 0);
    const totalPaid = ledgers.reduce((sum, entry) => sum + parseFloat(entry.credit || 0), 0);
    const totalOutstanding = ledgers.reduce((sum, entry) => sum + parseFloat(entry.debit || 0), 0);
    const totalInvoices = ledgers.length;

    setSelectedCustomerId(customer.id);
    setSelectedCustomerName(customer.name);
    setCustomerDetails({
      ...customer,
      totalSales,
      totalPaid,
      totalOutstanding,
      totalInvoices,
    });
    setCustomerLedgers(ledgers); // table shows immediately
  };



  // ===== Merge Invoice Counts =====
  const calculateMonthlyInvoices = async (customer) => {
    if (!customer?.id) return;

      try {
        // Fetch invoices for selected customer from fetch-sales-invoice
        const response = await api.get(`/v1/fetch-sales-invoice`);

      const allInvoices = response.data?.data || [];
      const customerInvoices = allInvoices.filter(
        (inv) => String(inv.customer_id) === String(customer.id)
      );

      // Filter invoices for current month
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();

      const monthlyInvoices = customerInvoices.filter((inv) => {
        const invDate = new Date(inv.transaction_date);
        return (
          invDate.getMonth() === currentMonth &&
          invDate.getFullYear() === currentYear
        );
      });

      // Ledger invoices (from customer endpoint)
      const ledgerInvoices = (customer.ledgers || []).length;

      // Merge counts
      return monthlyInvoices.length + ledgerInvoices;
    } catch (err) {
      console.error("Error calculating monthly invoices:", err);
      return 0;
    }
  };

  // ===== When selecting a customer =====
  const handleCustomerChange = async (value) => {
    setSelectedCustomerName(value);
    const match = customers.find(
      (c) => c.name.toLowerCase() === value.toLowerCase()
    );

    if (match) {
      setSelectedCustomerId(match.id);
      const ledgers = match.ledgers || [];

      const totalSales = ledgers.reduce(
        (sum, entry) => sum + parseFloat(entry.balance || 0),
        0
      );
      const totalPaid = ledgers.reduce(
        (sum, entry) => sum + parseFloat(entry.credit || 0),
        0
      );
      const totalOutstanding = ledgers.reduce(
        (sum, entry) => sum + parseFloat(entry.debit || 0),
        0
      );

      const mergedInvoices = await calculateMonthlyInvoices(match);

      setCustomerDetails({
        ...match,
        totalSales,
        totalPaid,
        totalOutstanding,
        totalInvoices: mergedInvoices || 0,
      });
    } else {
      setSelectedCustomerId("");
      setCustomerDetails(null);
    }
  };

  // ===== Filter invoices based on selected customer =====
  const filteredInvoices = selectedCustomerId
    ? invoiceItems.filter(
      (item) => String(item.customer_id) === String(selectedCustomerId)
    )
    : [];

  const handleProcess = async () => {
    setProcessing(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      // any API call logic here
    } catch (err) {
      console.error(err);
    } finally {
      setProcessing(false);
      setShowLedgerButton(true);
    }
  };


  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        <div className={classes.actions}>
          <button
            className={classes.btns}
            onClick={() => navigate("/transactions/receivables/sales")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button className={classes.btns_ss0}>Customer Sales</button>
          <button
            className={`${classes.btns} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Customer Sales</h2>
          <h1 className={classes.Titles}>
            Manage your sales transactions, invoices, and customer payments.
          </h1>
        </header>

        <div className={classes.actionsRight}>
          <div className={classes.inputWrapper}>
            <div className={classes.group}>
              {/* <input
                list="customer-list"
                placeholder={
                  customerLoading ? "Fetching customers..." : "Search or select customer"
                }
                value={selectedCustomerName}
                onChange={(e) => handleCustomerChange(e.target.value)}
              />

              <datalist id="customer-list">
                {customers.map((customer) => (
                  <option key={customer.id} value={customer.name} />
                ))}
              </datalist> */}
              <div className={classes.inputLoaderWrap}>
                <input
                  list="customer-list"
                  placeholder={customerLoading ? "Fetching customers..." : "Search or select customer"}
                  value={selectedCustomerName}
                  disabled={customerLoading}
                  aria-busy={customerLoading}
                  onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedCustomerName(value);

                  // Try to match customer by name
                  const match = customers.find(
                    (c) => c.name.toLowerCase() === value.toLowerCase()
                  );

                  if (match) {
                    setSelectedCustomerId(match.id);

                    // Fetch ledger immediately
                    setLedgerLoading(true);
                    try {
                      const res = await api.get(`/v1/customer/get-customer-ledger`, { params: { customer_id: match.id } });

                      const ledgerData = res.data.data || [];
                      setCustomerLedgers(ledgerData);

                      // Update cards data
                      const totalSales = ledgerData.reduce(
                        (sum, entry) => sum + parseFloat(entry.balance || 0),
                        0
                      );
                      const totalPaid = ledgerData.reduce(
                        (sum, entry) => sum + parseFloat(entry.credit || 0),
                        0
                      );
                      const totalOutstanding = ledgerData.reduce(
                        (sum, entry) => sum + parseFloat(entry.debit || 0),
                        0
                      );

                      setCustomerDetails({
                        ...match,
                        totalSales,
                        totalPaid,
                        totalOutstanding,
                        totalInvoices: ledgerData.length,
                      });
                    } catch (error) {
                      console.error("Failed to fetch customer ledger:", error);
                      setCustomerLedgers([]);
                      setCustomerDetails(null);
                    } finally {
                      setLedgerLoading(false);
                    }
                  } else {
                    setSelectedCustomerId("");
                    setCustomerLedgers([]);
                    setCustomerDetails(null);
                  }
                }}
                />
                {customerLoading && (
                  <span className={classes.ellipsisLoader} aria-hidden="true">
                    <span className={classes.dot}></span>
                    <span className={classes.dot}></span>
                    <span className={classes.dot}></span>
                  </span>
                )}
              </div>

              <datalist id="customer-list">
                {customers.map((c) => (
                  <option key={c.id} value={c.name} />
                ))}
              </datalist>



            </div>
            <div className={classes.inputWrapperd}>
              <button
                type="button"
                disabled={processing}
                onClick={handleProcess}
                className={classes.btnssd}
              >
                {processing ? "Processing..." : "Process"}
              </button>
            </div>
          </div>

          <div className={classes.inputWrapperd01}>

            {showLedgerButton && (
              <button
                type="button"
                className={classes.btnssd}
                onClick={() => {
                  console.log("Ledger opened");
                  navigate("/customer-personal-ledger", {
                    state: {
                      customerName: selectedCustomerName,
                      customerId: selectedCustomerId,
                      customerDetails: {
                        ...customerDetails,
                        ledgers: customerLedgers // Pass the current ledger data
                      },
                      filteredInvoices: customerLedgers, // Use ledgers as invoice data
                      totalSales: customerDetails?.totalSales || 0,
                      totalPaid: customerDetails?.totalPaid || 0,
                      totalOutstanding: customerDetails?.totalOutstanding || 0,
                      totalInvoices: customerDetails?.totalInvoices || 0,
                    },
                  });
                }}
              >
                View Personal Ledger
              </button>
            )}

          </div>
        </div>

        {/* Stats */}
        {/* {customerDetails && ( */}
        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total sales</p>
                <p className={classes.kdptg1}>
                  ₦{formatMoney(customerDetails?.totalSales || 0)}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Paid</p>
                <p className={classes.kdptg2}>
                  ₦{formatMoney(customerDetails?.totalPaid || 0)}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Debt Cleared</p>
                </div>
              </div>
            </div>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Outstanding</p>
                <p className={classes.kdptg3}>
                  ₦{formatMoney(customerDetails?.totalOutstanding || 0)}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total Credit</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>
                  {customerDetails?.totalInvoices || 0}
                </p>
                <div className={classes.rvnue}>
                  <p className={classes.skaltxt}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* )} */}

        {/* Invoices Table */}
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>S/N</th>
                <th>Transaction Date</th>
                <th>Invoice Number</th>
                <th>Customer</th>
                <th>Description</th>
                <th>Total Amount</th>
                <th>Debt</th>
                {/* <th>Status</th> */}
                <th>Sales Type</th>
                <th>Post Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {ledgerLoading ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                    Loading...
                  </td>
                </tr>
              ) : customerLedgers.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                    {selectedCustomerId
                      ? "No sales found for this customer."
                      : "Select Customer To See Customer Data."}
                  </td>
                </tr>
              ) : (
                customerLedgers.map((item, index) => {
                  const currentDebt = parseFloat(item.debit || item.balance || 0);
                  const totalAmount = parseFloat(item.balance || 0);
                  const paymentStatus = getPaymentStatus(currentDebt, totalAmount);

                  return (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      {/* <td>{item.transaction_date || "—"}</td> */}
                      <td>{item.created_at?.split("T")[0] || "—"}</td>
                      <td>{item.invoice_number || item.uuid || "—"}</td>
                      <td>{item.customer?.name || `Customer ${item.customer_id}`}</td>
                      <td>{item.description || "—"}</td>
                      <td style={{textAlign: "right"}}>{formatMoney(totalAmount)}</td>
                      <td style={{textAlign: "right"}}>{formatMoney(currentDebt)}</td>
                      {/* <td>
                        <span className={classes[paymentStatus.className]}>
                          {paymentStatus.status}
                        </span>
                      </td> */}
                      <td>
                        <span
                          className={
                            item.sales_type === "cash"
                              ? classes.statusCash
                              : classes.statusCredit
                          }
                        >
                          {item.sales_type === "cash" ? "Cash" : "Credit"}
                        </span>
                      </td>
                      <td>{item.created_at?.split("T")[0] || "—"}</td>
                      <td className={classes.actionsIcons}>
                        <Pencil
                          size={16}
                          style={{ color: "rgba(22, 163, 74, 1)", cursor: "pointer" }}
                          onClick={() => openEditModal(item)}
                        />
                        <Trash2 size={16} style={{ color: "rgb(255, 2, 2)", margin: "0 6px" }} />
                        <span
  onClick={() =>
    navigate("/reportinvoice", { state: { invoice: item, invoiceType: 'Sales Invoice' } })
  }
  style={{ cursor: "pointer" }}
>
  <Printer 
    size={16} 
    style={{ color: "rgba(37, 99, 235, 1)", cursor: "pointer" }}
  />
</span>

                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>

          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CustomerSales;